import React from 'react';
import { Box, Tab, TabProps } from '@material-ui/core';
import styles from './SGSTab.module.scss';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

type Props = TabProps & {
    backgroundColor?: string;
    count?: number;
};

const SGSTab: React.FC<Props> = ({ label, ...props }) => {
    const { t } = useTranslation();
    return (
        <Tab
            {...props}
            classes={{
                root: styles.tab,
                selected: classNames(styles.selected, props.backgroundColor),
                wrapper: styles.wrapper,
            }}
            label={
                <Box display="flex" gridGap="10px" alignItems="center">
                    {props.count >= 0 && <span className={styles.count}>{props.count}</span>}
                    <span>{t(label as string)}</span>
                </Box>
            }
        />
    );
};

export default SGSTab;
